
import { defineComponent } from 'vue'

import { wasm_eval } from 'flexwasm';

export default defineComponent({
    name: 'EditorView',
    data() {
      return {
        inputValue: '',
        evalValue: '',
      }
    },
    methods: {
      eval() {
        this.evalValue = wasm_eval(this.inputValue);
      }
    },
    mounted() {
      console.log(wasm_eval("1 + 1 * 3;"));
    },
})
